import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var INTERNAL_FEE_CODES = {
  REGISTRATION_CHARGES: 'REGISTRATION_CHARGES',
  BANK_OR_ACQUISITION_FEE: 'BANK_OR_ACQUISITION_FEE',
  WASTE_TIRE_FEE: 'WASTE_TIRE_FEE',
  STATE_FEE: 'STATE_FEE',
  TITLE_FEE: 'TITLE_FEE',
  LIEN_FEE: 'LIEN_FEE',
  DOCUMENTATION_FEE: 'DOCUMENTATION_FEE',
  TIRE_FEE: 'TIRE_FEE',
  SMOG_TO_STATE: 'SMOG_TO_STATE',
  LICENSE_FEE: 'LICENSE_FEE',
  SMOG_TO_SELLER: 'SMOG_TO_SELLER',
  FILLING_FEE: 'FILLING_FEE',
  EFF_FEE: 'EFF_FEE',
  PRIOR_LEASE_PAYOFF: 'PRIOR_LEASE_PAYOFF',
  USED_VEHICLE_CANCELLATION_FEE: 'USED_VEHICLE_CANCELLATION_FEE',
  EV_CHARGING_STATION: 'EV_CHARGING_STATION',
  EV_REGISTRATION: 'EV_REGISTRATION',
  DISPOSITION_FEE: 'DISPOSITION_FEE',
  STATE_EMISSION_CERTIFICATE_FEE: 'STATE_EMISSION_CERTIFICATE_FEE',
  STATE_EMISSION_EXEMPTION_FEE: 'STATE_EMISSION_EXEMPTION_FEE',
  EMISSION_TESTING_CHARGE: 'EMISSION_TESTING_CHARGE',
  PLATE_TRANSFER_FEE: 'PLATE_TRANSFER_FEE',
  PUBLIC_SAFETY_VEHICLE_FEE: 'PUBLIC_SAFETY_VEHICLE_FEE',
  TRANSFER_TAX: 'TRANSFER_TAX',
  WHEELAGE_TAX: 'WHEELAGE_TAX',
  TITLE_FEE_1: 'TITLE_FEE_1',
  TITLE_FEE_2: 'TITLE_FEE_2',
  TITLE_FEE_3: 'TITLE_FEE_3',
  LOAN_PROCESSING_FEE: 'LOAN_PROCESSING_FEE',
  INFRASTRUCTURE_FEE: 'INFRASTRUCTURE_FEE',
  CROSS_BORDER_LOCAL_FEE: 'CROSS_BORDER_LOCAL_FEE',
  ENVIRONMENT_PROTECT_FEE: 'ENVIRONMENT_PROTECT_FEE',
  LENDERS_AND_MEMBERS_FEE: 'LENDERS_AND_MEMBERS_FEE',
  PARTICIPATION_FEE: 'PARTICIPATION_FEE',
  PPSA_FEE: 'PPSA_FEE',
  RTA_TAXFEE: 'RTA_TAXFEE'
};
export var CUSTOM_FEE_IDS = _defineProperty({}, INTERNAL_FEE_CODES.BANK_OR_ACQUISITION_FEE, 101);